import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Regional} from "../../../shared/interface/regional";
import {HttpErrorResponse} from "@angular/common/http";
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {RegionalService} from "../../../shared/services/regional.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {HiperioConfigDirect} from "../../../shared/interface/hiperio-config-direct";
import {HiperioConfigDirectService} from "../../../shared/services/hiperio-config-direct.service";

@Component({
  selector: 'app-hiperio-config-direct-details',
  templateUrl: './hiperio-config-direct-details.component.html',
  styleUrls: ['./hiperio-config-direct-details.component.scss']
})
export class HiperioConfigDirectDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  hiperioConfigDirectId: string;
  hiperioConfigDirectObject?: HiperioConfigDirect;
  hiperioConfigDirect: ReplaySubject<HiperioConfigDirect> = new ReplaySubject<HiperioConfigDirect>(1);
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private hiperioConfigDirectService: HiperioConfigDirectService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.hiperioConfigDirectId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  load(): void {
    this.hiperioConfigDirectService.get(this.hiperioConfigDirectId).subscribe((hiperioConfigDirect: HiperioConfigDirect) => {
      this.hiperioConfigDirect.next(hiperioConfigDirect);
      this.hiperioConfigDirectObject = hiperioConfigDirect;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych regionalnego', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
